<div class="form-title">
  <div class="form-title-text">{{ data.title }}</div>
</div>
<mat-dialog-content
  ><div class="under-space">{{ data.text }}</div></mat-dialog-content
>
<mat-dialog-actions class="border-top justify-content-end">
  <button class="button" mat-button [mat-dialog-close]="false">
    {{ data.noText }}
  </button>
  <button class="button" mat-button [mat-dialog-close]="true">
    {{ data.yesText }}
  </button>
</mat-dialog-actions>
